
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import AutopartStore from '../../stores/AutopartStore'
class SWTStockPartItemEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initItem()
  }

  initItem(){
    return {needRefresh:false,itemcode:'',catSelect:null,description:'',price_per_unit:'',unit:'',quantity:'',productcode:''}
  }

  loadItemcode(item){
    console.log('loadItem',item)
    if(item!==null){
      this.setState(Object.assign(this.state,item,{catSelect:this.getSelectOption(item.category)}))      
    }else{
      this.setState(this.initItem)
    }
  }

  getSelectOption(categoryId){
    let catSelect = null
    this.props.catOptions.forEach((item,index)=>{
      if(item.value===categoryId){
        catSelect = item
      }
    })

    return catSelect

  }

  onTextChange(field,e){
    let state = this.state
    state[field] = e.target.value
    this.setState(state)
  }

  onPriceChange(e){
    this.setState({price:e.target.value})
  }

  onSelectChange(value){
    // let {catSelect} = this.state

    this.setState({catSelect:value})
  }

  onSelectOpen(){
    let {needRefresh} = this.state
    if(needRefresh){
      this.props.onRefreshOptions()
      this.setState({needRefresh:false})
    }
  }

  onSaveClick(){
    let that = this
    let {itemcode,description,catSelect,price} = this.state
    let postData = {itemcode:itemcode,description:description,category_id:catSelect.value,price:price}
    
    AutopartStore.saveStockPartItemcode(postData,function(){
      that.props.onAfterSubmit();
      that.props.onHide()
    })
  }

  onDelClick(){
    let that = this
    let {itemcode} = this.state
    
    
    AutopartStore.delStockPartItemcode(itemcode,function(){
      that.props.onAfterSubmit();
      that.props.onHide()
    })
  }

  onNewCatClick(){
    window.request_newcategory()
    this.setState({needRefresh:true})
  }

  renderHeader(){
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          หมวดหมู่
        </div>       
      </div>        
    )
  }

  renderForm(){
    let {catSelect,description,quantity,unit,price_per_unit} = this.state
    let {catOptions} = this.props
    return (
      <div className='row '>
        <div className='col-md-3 form-group'>
          <Select value={catSelect} 
          className={'select-plus'}
          onOpen={this.onSelectOpen.bind(this)}
          placeholder={'เลือกหมวดหมู่'} options={catOptions} onChange={this.onSelectChange.bind(this)}/>
          <Button  onClick={this.onNewCatClick.bind(this)}><FontAwesome name='plus'/></Button>        
        </div> 
        <div className='col-md-12' style={{display:'inline-flex'}}>
          
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th>รายการ</th>
                <th>จำนวน</th>
                <th>หน่วยนับ</th>
                <th>ราคาต่อหน่วย</th>
              </tr>
            </thead>
          <tbody>
          <tr >
            <td><FormControl value={description} onChange={this.onTextChange.bind(this,'description')}/>          </td>
            <td><FormControl value={quantity} onChange={this.onTextChange.bind(this,'quantity')}/>          </td>
            <td><FormControl value={unit} onChange={this.onTextChange.bind(this,'unit')}/>          </td>
            <td><FormControl value={price_per_unit} onChange={this.onTextChange.bind(this,'price_per_unit')}/>          </td>
          </tr>
          </tbody>
          </table>
        </div> 

      </div>
    )
  }

  render(){
    let {show} = this.props
    let {itemcode} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'แก้ไขรายการอะไหล่ในสต๊อก'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderHeader()}
          {this.renderForm()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:(itemcode!=='')?'block':'none'}} bsStyle={'danger'}  onClick={this.onDelClick.bind(this)}>ลบข้อมูล</Button>
            <Button bsStyle={'primary'}  onClick={this.onSaveClick.bind(this)}>บันทึกข้อมูล</Button>
            <Button onClick={this.props.onHide}>ยกเลิก</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SWTStockPartItemEditModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTStockPartItemEditModal.js